<template>
    <div class="gray-back" style="padding:.2rem 0 3rem 0 ;  height: 100%">
        <van-notice-bar :scrollable="true" @click="edit">
            本地队伍可以选择不住宿，无需填写接送站信息，如有问题点这里
        </van-notice-bar>
        <div v-if="pageData.confirm_4!=1">
            <van-divider>单位信息</van-divider>
            <van-cell-group>
                <van-cell title="赛季" :value="pageData.sjname" />
                <van-cell title="赛区" :value="pageData.sqname" />
                <van-cell title="单位" :value="pageData.danwei" />
                <van-cell title="队伍名称" :value="pageData.mingcheng" />
                <van-cell title="食宿人数" :value="pageData.total_member_count" />
            </van-cell-group>
            <van-divider>时间填写</van-divider>
            <van-cell-group>
                <!-- <van-field
                        required
                        clearable
                        v-model="formData.come_station_name"
                        label="接站地点"
                        readonly
                        @click="showStation=true;stationField='come'"
                        placeholder="请选择接站地点"
                >
                </van-field>
                <van-field
                        required
                        clearable
                        v-model="formData.come_transcode"
                        :rules="[{ required: true, message: '不能为空' }]"
                        label="车次"
                        placeholder="请输入车次或者航班号"
                >
                </van-field> -->
                <van-cell
                        title="人数"
                >
                <van-stepper
                        required
                        v-model="formData.come_member_count"
                        placeholder="请输入人数"
                        :min="1"
                        :max="pageData.total_member_count"
                        @change="memberChange"
                >
                </van-stepper>
                </van-cell>
                <van-field
                        required
                        clearable
                        v-model="formData.come_date_time"
                        label="到达酒店时间"
                        readonly
                        @click="showTime=true;timeField='come'"
                        placeholder="请选择到达酒店时间"
                >
                </van-field>
                <van-field
                    v-model="formData.come_note"
                    label="留言"
                    type="textarea"
                    placeholder="您还有其他诉求吗？"
                    autosize 
                />
            </van-cell-group>

            <div style="position: fixed; bottom: 0px; z-index: 1000; width: 100%">
                <van-datetime-picker
                        v-if="showTime"
                        type="datetime"
                        :min-date="new Date()"
                        @confirm="timeConfirm"
                        @cancel="showTime=false"
                        :formatter="formatter"
                />

                <van-picker v-if="showStation"
                            show-toolbar
                            title="选择站点"
                            :columns="pageData.station_list"
                            value-key="name"
                            @cancel="showStation=false"
                            @confirm="stationConfirm" />
            </div>
        </div>
        <div v-else>
            <van-divider>单位信息</van-divider>
            <van-cell-group>
                <van-cell title="赛季" :value="pageData.sjname" />
                <van-cell title="赛区" :value="pageData.sqname" />
                <van-cell title="单位" :value="pageData.danwei" />
                <van-cell title="队伍名称" :value="pageData.mingcheng" />
            </van-cell-group>
            <van-divider>时间填写</van-divider>
            <van-cell-group>
                <!-- <van-cell title="接站地点" :value="pageData.bus_take.come_station_name" /> -->
                <!-- <van-cell title="车次" :value="pageData.bus_take.come_transcode" /> -->
                <van-cell title="人数" :value="pageData.bus_take.come_member_count" />
                <van-cell title="到达酒店时间" :value="pageData.bus_take.come_date_time|date" />
                <van-cell title="备注" :value="pageData.bus_take.come_note" />
            </van-cell-group>



            <van-divider>车辆信息</van-divider>
            <van-cell-group v-if="pageData.bus_list.length">
                <van-cell v-for="(bus,index) in pageData.bus_list" :title="bus.name" v-if="bus.type==1"  >
                    <div v-if="bus.type==1"> 接站 </div>
                    <div v-else> 送站 </div>
                </van-cell>
            </van-cell-group>
            <van-divider v-else >等待更新</van-divider>

        </div>

        <div style="padding: 20px;">
            <!-- <van-button type="primary"  size="large"  v-if="pageData.confirm_4==2" @click.stop="add">提交信息</van-button> -->
            <van-button type="primary"  size="large"    v-if="pageData.confirm_4!=1" @click.stop="add">保存信息</van-button>
            <van-button type="primary"  size="large" plain style="margin: 10px 0"  v-if="pageData.confirm_4==3" @click.stop="save">信息无误 我已确认</van-button>
            <van-button   type="primary" size="large"  plain v-if="pageData.confirm_4==1" >信息已确认</van-button>
            <!-- <van-button   type="primary" size="large"  plain style="margin: 10px 0" v-if="pageData.confirm_4==2" @click.stop="cancel" >我不需要接送站</van-button> -->
            <!-- <van-button size="large" plain style="margin: 10px 0" @click.stop="edit">信息需要修改</van-button> -->
            <van-button size="large" plain style="margin: 10px 0" @click.stop="goIndex">返回首页</van-button>
        </div>


    </div>
</template>

<style scoped="">
</style>
<script>
    Date.prototype.Format = function(fmt) {
        var o = {
            "M+" : this.getMonth() + 1,
            "d+" : this.getDate(),
            "h+" : this.getHours(),
            "m+" : this.getMinutes(),
            "s+" : this.getSeconds(),
            "q+" : Math.floor((this.getMonth() + 3) / 3),
            "S" : this.getMilliseconds()
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog,Stepper,Toast
    } from 'vant';
    export default {
        name: 'saiConfirmDetail4',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Stepper.name]: Stepper,
            [Toast.name]: Toast,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'station_list' :[],
                    'bus_take' :[],
                    'bus_list':[],
                    'face' :'',
                    'phone' :'',
                },
                formData:{
                    'id' : this.$route.query.id,
                    'come_station_name' :'',
                    'come_station_id' :0,
                    'come_transcode' :'',
                    'come_member_count' :0,
                    'come_date_time' :'',
                    'come_note' :'',
                    'go_station_name' :'',
                    'go_station_id' :0,
                    'go_transcode' :'',
                    'go_member_count' :0,
                    'go_date_time' :'',
                },
                showTime:false,
                timeField:'',
                showStation:false,
                stationField:'',
            }
        },
        mounted: function () {
            let that = this;
            document.title = "接送站信息确认";
            this.$api.get('/api/sai/confirmtakedetail', {
                'id':that.pageData.id
            }, r => {
                this.pageData = r.data;
                this.pageData.bus_take = r.data.bus_take==null ? {} :r.data.bus_take;
                this.formData.come_station_name = r.data.come_station_name;
                this.formData.come_station_id = r.data.come_station_id;
                this.formData.come_transcode = r.data.come_transcode;
                this.formData.come_member_count = r.data.come_member_count;
                this.formData.come_date_time = r.data.come_date_time;
                this.formData.come_note = r.data.come_note;
                if(this.formData.come_member_count==0){
                    this.formData.come_member_count = this.pageData.total_member_count
                }
                if(this.formData.go_member_count==0){
                    this.formData.go_member_count = this.pageData.total_member_count
                }
            });

        },
        filters:{
          date:function (value) {
              return (new Date(value*1000).Format("yyyy-MM-dd hh:mm"));
          }
        },
        methods: {
            goIndex:function () {
                this.$router.push({
                    'name' :'saiConfirmManage',
                    'query':{}
                })
            },
            memberChange:function (value){
                if(value > this.pageData.total_member_count){
                    this.$toast.center('接送人数不能大于住宿人数,如有疑问可联系cca工作人员');
                    return ;
                }
            },
            selectComeStation:function (station_id) {
                let that = this;
                that.formData.come_station_id = station_id;
            },
            timeConfirm:function (value) {
                let that = this;
                if(that.timeField =='come'){
                    that.formData.come_date_time = (new Date(value).Format("yyyy-MM-dd hh:mm"));
                }else{
                    that.formData.go_date_time = (new Date(value).Format("yyyy-MM-dd hh:mm"));
                }
                that.showTime = false;
            },
            stationConfirm:function (value) {
                let that = this;
                if(that.stationField =='come'){
                    that.formData.come_station_id = value.id;
                    that.formData.come_station_name = value.name;
                }else{
                    that.formData.go_station_id = value.id;
                    that.formData.go_station_name = value.name;
                }
                that.showStation = false;
            },
            add:function () {
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '您确定信息准确无误吗?提交后不得修改!'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/sai/confirmtakeaddaction', this.formData, r => {
                        if(that.$route.query.from=='app'){
                            rbLink({
                                "name":'xxx'
                            },'back');
                        }else{
                        that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
                        }
                    },r=>{
                        Toast(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });
            },
            edit:function () {
                let that = this;
                this.$router.push({
                    'name' :'saiConfirmQr2',
                    'query':{'id':that.pageData.id}
                })
            },
            save:function () {
                let that = this;
                Dialog.confirm({
                    title: '确认',
                    message: '您确定信息准确无误吗?提交后不得修改!'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/sai/confirmtakeaction', this.formData, r => {
                        if(that.$route.query.from=='app'){
                            rbLink({
                                "name":'xxx'
                            },'back');
                        }else{
                        that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
                        }
                    },r=>{
                        Toast(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });
            },
            cancel:function () {
                let that = this;
                Dialog.confirm({
                    title: '取消接送站',
                    message: '您确定不需要接送站吗?提交后不得修改!'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/sai/confirmtakecancelaction', this.formData, r => {
                        that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
                    },r=>{
                        Toast(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });
            },formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                } else if (type === 'day') {
                    return `${value}日`
                } else if (type === 'hour') {
                    return `${value}时`
                } else if (type === 'minute') {
                    return `${value}分`
                }
                return value;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// saiConfirmDetail4.vue?5e5d8ad6